<template>
  <div class="box">
    <div class="work">
      <!--路径 -->
      <div class="path">
        <img class="path_img" src="../../../../../assets/images/path.png"/>
        <div class="path_txt">运营管理系统 > 合作伙伴 > 运营投放</div>
      </div>
      <!--查询条件-->
      <div class="condition">
        <div class="condi_line">
          <div class="condi_item">
            <div class="condi_item_label">应用:</div>
            <div class="condi_item_cnt">
              <el-select v-model="searchCondition.appId" filterable  clearable  placeholder="请选择应用">
                <el-option
                        v-for="app in apps"
                        :key="parseInt(app.app_id)"
                        :label="'(' + app.app_id + ')' + app.app_name"
                        :value="parseInt(app.app_id)">
                </el-option>
              </el-select>
            </div>
          </div>
          <div class="condi_item">
            <div class="condi_item_label">应用类型:</div>
            <div class="condi_item_cnt">
              <el-select v-model="searchCondition.appType" filterable  clearable  placeholder="请选择应用类型">
                <el-option
                        v-for="key in Object.keys(appTypes)"
                        :key="key"
                        :label="'(' + key + ')' + appTypes[key]"
                        :value="key">
                </el-option>
              </el-select>
            </div>
          </div>
          <div class="condi_item">
            <div class="condi_item_label">投放平台：</div>
            <div class="condi_item_cnt">
              <el-select v-model="searchCondition.issuePlatform" filterable clearable @change="loadIssueFlows" placeholder="请选择投放平台">
                <el-option
                      v-for="item in issuePlatforms"
                      :key="item.issue_platform_tag"
                      :label="item.issue_platform_name"
                      :value="item.issue_platform_tag">
                </el-option>
              </el-select>
            </div>
          </div>
          <div class="condi_item">
            <div class="condi_item_label">投放流量：</div>
            <div class="condi_item_cnt">
              <el-select v-model="searchCondition.issueFlow" filterable clearable placeholder="请选择投放平台流量">
                <el-option
                      v-for="item in issueFlows"
                      :key="item.issue_flow_tag"
                      :label="item.issue_flow_name"
                      :value="item.issue_flow_tag">
              </el-option>
              </el-select>
            </div>
          </div>
        </div>

        <div class="condi_line">
          <div class="condi_item">
            <div class="condi_item_label">渠道:</div>
            <div class="condi_item_cnt">
              <el-select v-model="searchCondition.channelId" filterable clearable placeholder="请选择渠道">
                <el-option
                        v-for="item in channels"
                        :key="item.channel_id"
                        :label="'(' + item.channel_id + ')' + item.channel_name"
                        :value="item.channel_id">
                </el-option>
              </el-select>
            </div>
          </div>
          <div class="condi_item">
            <div class="condi_item_label">渠道号:</div>
            <div class="condi_item_cnt">
              <el-input v-model="searchCondition.channelSlotId" clearable placeholder="请输入渠道号" />
            </div>
          </div>
          <div class="condi_item">
            <div class="condi_item_label">投放账户:</div>
            <div class="condi_item_cnt">
              <el-input v-model="searchCondition.account" clearable placeholder="查询账户信息" />
            </div>
          </div>
          <div class="condi_item">
            <div class="condi_item_label">审核状态:</div>
            <div class="condi_item_cnt">
              <el-select v-model="searchCondition.approveStatus" clearable placeholder="所有状态">
                <el-option
                  v-for="key in Object.keys(approveStatusMap)"
                  :key="parseInt(key)"
                  :label="approveStatusMap[key]"
                  :value="parseInt(key)"
                >
                </el-option>
              </el-select>
            </div>
          </div>
        </div>
        <div class="condi_line">
          <div class="condi_item">
            <div class="condi_item_label"></div>
            <div class="condi_item_cnt">
              <el-button type="primary" @click="onSearch">查询</el-button>
            </div>
          </div>
        </div>
      </div>
      <!--数据列表-->
      <div class="datalist">
        <div class="dtlst_top">
          <div class="dtlst_title">广告列表</div>
          <div class="dtlst_btn">
            <el-button @click="add">新增</el-button>
          </div>
        </div>
        <div class="dtlst_table">
          <el-table
            :data="pageTable.tableData"
            stripe
          >
            <el-table-column prop="app_issue_id" label="ID" width="70px">
              <template slot-scope="scope">{{scope.row.app_issue_id}}</template>
            </el-table-column>
            <el-table-column prop="app_id,app_name" label="应用" width="110px">
              <template slot-scope="scope">({{scope.row.app_id}}){{scope.row.app_name}}</template>
            </el-table-column>
            <el-table-column prop="app_type" label="应用类型" width="90px">
              <template slot-scope="scope">{{scope.row.app_type ? '(' + scope.row.app_type + ')' : ''}}{{appTypes[scope.row.app_type]}}</template>
            </el-table-column>
            <el-table-column prop="issue_platform" label="投放平台" width="80px">
              <template slot-scope="scope">{{scope.row.issue_platform ? issuePlatforms.find(item=>item.issue_platform_tag==scope.row.issue_platform).issue_platform_name : ''}}</template>
            </el-table-column>
            <el-table-column prop="issue_flow" label="投放流量" width="110px">
              <template slot-scope="scope">{{scope.row.issue_flow ? issueFlows.find(item=>item.issue_flow_tag==scope.row.issue_flow).issue_flow_name : ''}}</template>
            </el-table-column>
            <el-table-column prop="issue_account" label="投放账号" width="190px">
              <template slot-scope="scope">{{scope.row.issue_account}}</template>
            </el-table-column>
            <el-table-column prop="channel_id,channel_name" width="140px" label="渠道">
              <template slot-scope="scope">({{scope.row.channel_id}}){{scope.row.channel_name}}</template>
            </el-table-column>
            <el-table-column prop="channel_slot_id" width="80px" label="渠道号">
              <template slot-scope="scope">{{scope.row.channel_slot_id}}</template>
            </el-table-column>
            <el-table-column prop="measure_id,measure_title" label="投放内容" width="240px">
              <template slot-scope="scope">
                {{scope.row.book_id && books.find(item => item.book_id == scope.row.book_id) ? '[说]' + books.find(item => item.book_id == scope.row.book_id).book_name : ''}}
                {{scope.row.measure_id && appraises.find(item => item.appraise_id == scope.row.measure_id) ? '[测]' + appraises.find(item => item.appraise_id == scope.row.measure_id).appraise_title : ''}}
                {{scope.row.shortplay_id && scope.row.app_id!=30 && shortplays.find(item => item.shortplay_id == scope.row.shortplay_id) ? '[剧]' + shortplays.find(item => item.shortplay_id == scope.row.shortplay_id).shortplay_name : ''}}
                
                {{scope.row.shortplay_id && scope.row.app_id==30 && scope.row.app_type==61 && oshortplays.find(item => item.shortplay_id == scope.row.shortplay_id) ? '[剧]' + oshortplays.find(item => item.shortplay_id == scope.row.shortplay_id).shortplay_name : ''}}
                {{scope.row.shortplay_id && scope.row.app_id==30 && scope.row.app_type==62 && vshortplays.find(item => item.shortplay_id == scope.row.shortplay_id) ? '[剧]' + vshortplays.find(item => item.shortplay_id == scope.row.shortplay_id).shortplay_name : ''}}
                
                {{scope.row.cookbook_id ? '[菜]' + cookbooks[scope.row.cookbook_id] : ''}}
                {{scope.row.health_class_id!=undefined ? '[养分]' + health_classes[scope.row.health_class_id] : ''}}
                {{scope.row.health_id ? '[养]' + healthes[scope.row.health_id] : ''}}
              </template>
            </el-table-column>
            <el-table-column prop="issue_effect_type" label="效果回传" width="110px">
              <template slot-scope="scope">
                {{issueEffects.find(item=>item.issue_platform_tag==scope.row.issue_platform && item.issue_effect_tag==scope.row.issue_effect_type) ? issueEffects.find(item=>item.issue_platform_tag==scope.row.issue_platform && item.issue_effect_tag==scope.row.issue_effect_type).issue_effect_name : ''}}
              </template>
            </el-table-column>
            <el-table-column prop="approve_status" label="审核状态" width="110">
              <template slot-scope="scope">
                <el-tag width="60" type="primary" v-if="scope.row.approve_status==0">{{approveStatusMap[scope.row.approve_status]}}</el-tag>
                <el-tag width="60" type="danger" v-else-if="scope.row.approve_status==1">{{approveStatusMap[scope.row.approve_status]}}</el-tag>
                <el-tag width="60" type="success" v-else-if="scope.row.approve_status==2">{{approveStatusMap[scope.row.approve_status]}}</el-tag>
              </template>
            </el-table-column>
            <el-table-column prop="approve_time" label="审核时间" width="120">
              <template slot-scope="scope">
                {{scope.row.approve_time_serial ? scope.row.approve_time_serial.substring(5,16) : ''}}
              </template>
            </el-table-column>
            <el-table-column label="操作" width="280">
              <template slot-scope="scope">
                <div class="dtlst_operation">
                  <el-button type="success" size="small" @click="detail(scope.row)">详情</el-button>
                  <el-button type="info" size="small" @click="copy(scope.row)">复制</el-button>
                  <el-button type="primary" size="small" @click="update(scope.row)">编辑</el-button>
                  <el-button type="danger" size="small" @click="remove(scope.row)">删除</el-button>
                </div>
              </template>
            </el-table-column>
          </el-table>
          <div class="dtlst_pagination">
            <el-pagination
              background
              layout="total, sizes, prev, pager, next, jumper"
              :current-page="pageTable.pageIndex"
              :page-size="pageTable.pageSize"
              :page-sizes="[5, 10, 20, 50, 100, 200, 500]" 
              :page-count="pageTable.pageCount"
              :total="pageTable.recordTotalCount"
              @current-change="changeCurrPage"
              @size-change="changePageSize"
            >
            </el-pagination>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {MessageBox} from 'element-ui';

export default {
  data() {
    return {
      // 操作员对象
      operator: null,

      // 分页表格
      pageTable: {
        pageIndex: 1,         //当前页索引
        pageSize: 100,        //本页显示数量
        pageCount: 1,         //分页总数
        recordTotalCount: 0,  //记录
        tableData: [],        // 应用列表数据
      },
      
      // 搜索的参数
      searchCondition: {
        appId: null,          //应用ID
        appType: null,        //应用类型
        issuePlatform: null,  //投放平台
        issueFlow: null,      //投放平台流量
        channelId: null,      //渠道ID
        channelSlotId: null,  //渠道位置ID
        account: null,        //投放账户信息
        issueStatus: 1,       //投放状态
        approveStatus: null,  //投放审核状态
      },

      apps: null,             //应用集合
      channels: null,         //渠道列表
      
      appraises: null,        //测评列表(新)
      books: null,            //小说
      shortplays: null,       //短剧

      vshortplays: null,      //vivo 短剧
      oshortplays: null,      //oppo 短剧

      // 投放平台、流量、效果列表
      issuePlatforms: [],
      issueFlows: [],
      issueEffects: [],
      
      // 应用类型
      appTypes: {
        5: "H5",
        61: "OPPO",
        62: "VIVO",
        63: "小米",
        65: "华为",
      },

      // 广告资源位打底广告场景
      adResourceBidbases: {
        1: '打底场景 1',
        2: '打底场景 2',
        3: '打底场景 3',
        4: '打底场景 4',
        5: '打底场景 5',
      },

      // 广告场景
      issueAdScenes: {
        1: '广告场景 1',
        2: '广告场景 2',
        3: '广告场景 3',
        4: '广告场景 4',
        5: '广告场景 5',
      },

      // 状态
      issueStatusMap: {
        1: "有效",
        0: "无效"
      },  
          
      // 审核状态
      approveStatusMap: {
        0:  "待审核",
        1:  "审核不通过",
        2:  "审核通过"
      },   


      // 菜谱
      cookbooks: {
        1:    '红烧肉',
        2:	  '排骨玉米汤',
        3:	  '鱼香肉丝',
        4:	  '炸酱面',
        5:	  '糖醋排骨',
        6:	  '可乐鸡翅',
        7:	  '红焖羊排萝卜',
        8:	  '木须肉',
        9:	  '酸辣土豆丝',
        10:	  '芒果圆子西米露',
        11:   '白菜豆腐煲',
        12:	  '油闷大虾',
        13:	  '煎蛋白菜豆腐汤',
        14:	  '照烧肥牛饭',
        15:   '东北锅包肉',
        16:   '家庭版葡式蛋挞',
        17:	  '秋葵',
        18:	  '三鲜饺子',
        19:	  '咖喱鸡肉饭',
        20:	  '酸辣汤',
        99999:'转盘'
      },

      // 健康养生
      healthes: {
        1:    '警惕亚健康，守护生命活力',
        2:	  '如何呵护颈椎健康',
        3:	  '如何远离腰椎问题',
        4:	  '关注 “工作病”，守护职场健康',
        5:	  '女性经期养生指南',
        6:	  '孕期养生指南',
        7:	  '老年人如何吃才健康？',
        8:	  '老年常见疾病如何预防？',
        9:	  '运动，让老人更健康的秘诀',
        10:	  '老年人觉少正常吗？',
        11:   '解压木鱼真的解压吗',
        12:	  '音乐如何助眠',
        13:	  '摆脱睡眠困扰',
        14:	  '冥想的妙用',
        15:   '冥想，减压神器',
        16:   '音乐，让睡眠更轻松',
        17:	  '常见食材的养生功效',
        18:	  '慢食文化与健康',
        19:	  '胶原蛋白的秘密',
        20:	  '食物搭配禁忌表',
        21:   '暖冬滋补秘籍',
        22:   '顺应节气，吃出健康',
        23:   '如何健康瘦？',
        24:   '八段锦古法养生',
        25:   '上班族如何保持日常运动',
        26:   '日常运动养生小技巧',
        27:   '瑜伽的好处',
        28:   '传统健身的养生智慧',
        29:   '选择合适的户外运动',
        30:   '科学健身',
      },

      health_classes: {
        0:    '食材养生',
        1:	  '冥想疗愈',
        2:	  '运动养生',
        3:	  '养生人群',
      },
    }
  },
  
  created() {
    // 从缓存中恢复操作员对象
    let operatorSerial = localStorage.getItem('operator');
    if(operatorSerial==null || operatorSerial==undefined || operatorSerial=='') {
      // 返回登录页面
      this.$router.push('/');
      return;
    }
    this.operator = JSON.parse(operatorSerial);
    // 初始化数据
    this.initApps();
    this.initChannels();
    this.initIssuePlatforms();
    this.loadIssueFlows();
    this.loadIssueEffects();
    this.initAppraises();
    this.initBooks();
    this.initShortplays();
    // 加载数据
    this.loadData();
  },
  
  methods: {
    // 初始化应用
    async initApps(){
      // 清空当前集合数据
      this.apps = null;
      // 调用接口
      let res = await this.$api.apiPartnerCommonApps({
        operatorId: this.operator.operatorId
      });
      // 应用数据存进data
      this.apps = res.content;
    },

    // 初始化渠道
    async initChannels() {
      // 清空当前渠道
      this.channels = [];
      // 调用接口
      let res = await this.$api.apiPartnerCommonChannels({
        operatorId: this.operator.operatorId
      });
      // 保存结果
      this.channels = res.content;
    },

    // 初始化发布平台
    async initIssuePlatforms() {
      // 清空当前渠道
      this.issuePlatforms = [];
      // 调用接口
      let res = await this.$api.apiCommonIssuePlatforms();
      // 保存结果
      this.issuePlatforms = res.content;
    },

    // 加载发布平台流量类型
    async loadIssueFlows() {
      // 清空当前流量类型
      this.searchCondition.issueFlow = null;
      this.issueFlows = [];
      // 调用接口
      let res = await this.$api.apiCommonIssueFlows({issuePlatformTag: this.searchCondition.issuePlatform});
      // 保存结果
      this.issueFlows = res.content;
    },

    // 加载发布平台效果数据回传类型
    async loadIssueEffects() {
      // 调用接口
      let res = await this.$api.apiCommonIssueEffects();
      // 保存结果
      this.issueEffects = res.content;
    },
    
    // 初始化测评(新)
    async initAppraises() {
      // 清空当前测评
      this.appraises = [];
      // 调用接口
      let res = await this.$api.apiCommonAppraises();
      // 保存结果
      this.appraises = res.content;
    },

    // 初始化小说
    async initBooks() {
      // 清空当前测评
      this.books = [];
      // 调用接口
      let res = await this.$api.apiCommonBooks();
      // 保存结果
      this.books = res.content;
    },

    // 初始化短剧
    async initShortplays() {
      // 加载短剧
      this.shortplays = null;
      let res = await this.$api.apiCommonShortplays();
      this.shortplays = res.content;

      // 加载 vivo 短剧
      this.vshortplays = null;
      res = await this.$api.apiCommonVshortplays();
      this.vshortplays = res.content;

      // 加载 oppo 短剧
      this.oshortplays = null;
      res = await this.$api.apiCommonOshortplays();
      this.oshortplays = res.content;
    },
    
    // 加载数据
    async loadData() {
      // 显示页面加载
      const loading = this.$loading({
        lock: true,//lock的修改符--默认是false
        text: 'Loading',//显示在加载图标下方的加载文案
        spinner: 'el-icon-loading',//自定义加载图标类名
        background: 'rgba(0, 0, 0, 0.7)',//遮罩层颜色
        target: '.box'//遮罩区域
      });
      // 获取请求参数
      let params = new Object();
      params['pageIndex'] = this.pageTable.pageIndex;
      params['pageSize'] = this.pageTable.pageSize;
      params['operatorId'] = this.operator.operatorId;
      params['appId'] = this.searchCondition.appId;
      params['appType'] = this.searchCondition.appType;
      params['issuePlatform'] = this.searchCondition.issuePlatform;
      params['issueFlow'] = this.searchCondition.issueFlow;
      params['channelId'] = this.searchCondition.channelId;
      params['channelSlotId'] = this.searchCondition.channelSlotId;
      params['account'] = this.searchCondition.account;
      params['issueStatus'] = this.searchCondition.issueStatus;
      params['approveStatus'] = this.searchCondition.approveStatus;
      // 清空当前集合数据
      this.pageTable.tableData = [];
      // 调用接口
      let res = await this.$api.apiPartnerQuickAppIssueList(params);
      if(res.result !== 1) {
        this.$message("加载数据列表失败","warning");
        // 加载结束
        loading.close();
        return;
      }
      // 获取分页数据
      this.pageTable.pageIndex = res.content.pageIndex;
      this.pageTable.pageSize = res.content.pageSize;
      this.pageTable.pageCount = res.content.pageCount;
      this.pageTable.recordTotalCount = res.content.recordTotalCount;
      // 应用数据存进data
      this.pageTable.tableData = res.content.records;
      // 加载结束
      loading.close();
    },
    
    // 搜索应用
    async onSearch(){
      // 先清空原有数据
      this.pageTable.tableData = [];
      // 查询应用
      this.loadData();
    },

    // 详情
    async detail(data) {
      // 验证参数有效性
      if(data.app_issue_id==null || data.app_issue_id==undefined) {
        return;
      }
      // 进入修改页面
      this.$router.push({name:'running.partner.issue.issue',params:data});
    },

    // 复制
    async copy(data) {
      // 验证参数有效性
      if(data.app_issue_id==null || data.app_issue_id==undefined) {
        return;
      }
      // 进入新增页面
      this.$router.push({name:'running.partner.issue.add',params:data});
    },

    // 新增
    async add() {
      // 进入新增页面
      this.$router.push({name:'running.partner.issue.add'});
    },

    // 编辑
    async update(data) {
      // 验证参数有效性
      if(data.app_issue_id==null || data.app_issue_id==undefined) {
        return;
      }
      // 进入修改页面
      this.$router.push({name:'running.partner.issue.update',params:data});
    },

    // 删除
    async remove(data) {
      // 确认删除
      MessageBox.confirm('请确认是否删除当前快应用推广？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        // 显示页面加载
        const loading = this.$loading({
          lock: true,
          text: 'Processing ......',
          spinner: 'el-icon-loading',
          background: 'rgba(0, 0, 0, 0.7)',
          target: '.box'
        });
        // 调用删除
        this.$api.apiQuickAppIssueDelete({appIssueId: data.app_issue_id}).then(res => {
          if (res.result === 1) {
            // 从data中移除这一项
            this.$delete(this.pageTable.tableData,this.pageTable.tableData.findIndex((item) => item.app_issue_id === data.app_issue_id));
            // 请求成功
            this.$message("删除成功", "success");
          } else {
            // 操作失败
            this.$message(res.message, "warning");
          }
        });
        // 关闭加载
        loading.close();
      }).catch(() => {});
    },
    
    // 变更当前页面
    async changeCurrPage(currPage) {
      this.pageTable.pageIndex = currPage;
      this.loadData();
    },

    // 变更页面大小
    async changePageSize(pageSize) {
      this.pageTable.pageSize = pageSize;
      this.pageTable.pageIndex = 1;
      this.loadData();
    }
  },
};
</script>
<style lang='scss' scoped>
.box {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  flex-wrap: nowrap;
  align-items: center;
  overflow: auto;
}
.work {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  flex-wrap: nowrap;
  align-items: center;
  overflow: auto;
}
.path {
  margin: 10px 5px 0px 15px;
  padding: 0px;
  width: 100%;
  height: 20px;
  color: rgb(6, 6, 31);
  font-size: 1rem;
  display: flex;
  justify-content: flex-start;
  flex-wrap: nowrap;
  flex-direction: row;
  align-items: center;
}
.path_img {
  margin-right:5px;
  height: 15px;
  width: 15px;
}
.path_txt {
  width: 100%;
  height: 20px;
  text-align: left;
}
.condition {
  margin: 10px 10px 10px 10px;
  padding: 5px 5px 5px 5px;
  width: 98%;
  height: auto;
  display: flex;
  flex-direction: row column;
  justify-content: flex-start;
  flex-wrap: wrap;
  background: #fff;
  border-radius: 9px;
  align-items: center;
}
.condi_line {
  width: 100%;
  height: 50px;
  display: flex;
  justify-content: flex-start;
  flex-wrap: nowrap;
  flex-direction: row column;
  background: #fff;
  border-radius: 9px;
  align-items: center;
}
.condi_item {
  margin-left: 30px;
  width: 240px;
  height: 36px;
  display: flex;
  align-items: center;
}
.condi_item_max {
  margin-left: 30px;
  width: 310px;
  height: 36px;
  display: flex;
  align-items: center;
}
.condi_item_label {
  text-align: left;
  width: 80px;
  font-size: 16px;
}
.condi_item_cnt {
  width: 160px;
  font-size: 16px;
}
.condi_item_cnt_max {
  width: 230px;
  font-size: 16px;
}
.condi_item_cnt .el-input {
  width: 160px;
}
.condi_item_cnt_max .el-input {
  width: 230px;
}
.condi_item_cnt .el-select {
  width: 160px;
}
.condi_item_cnt_max .el-select {
  width: 230px;
}
.condi_item_cnt .el-button {
  width: 160px;
}
.condi_item_cnt_max .el-date-picker {
  width: 230px;
}
.datalist {
  margin: 0px 10px 10px 10px;
  padding: 5px 5px 5px 5px;
  width: 98%;
  height: auto;
  display: flex;
  justify-content: flex-start;
  flex-wrap: wrap;
  flex-direction: row;
  border-radius: 9px;
  overflow: auto;
  background: #fff;
}
.datalist .el-table {
  margin: 0 auto;
  width: 96%;
}
.dtlst_top {
  margin: 10px 10px 10px 15px;
  width: 96%;
  height: 25px;
  display: flex;
  justify-content: flex-start;
  flex-wrap: nowrap;
  flex-direction: row;
  align-items: center;
  align-items: center;
  background: #fff;
}
.dtlst_title {
  color: black;
  font-size: 1rem;
  font-weight: 500;
  height: 25px;
  text-align: left;
}
.dtlst_btn {
  height: 20px;
  width: calc(100% - 100px);
  text-align: right;
}
.dtlst_btn .el-button {
  margin: 0px 0px 0px 10px;
  padding: 0px 10px 0px 10px;
  color: white;
  background: #1890ff;
  height: 25px;
  min-width: 80px;
  width: auto;
}
.dtlst_table {
  width: 98%;
  height: auto;
}
.dtlst_operation {
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: flex-start;
  align-items: center;
}
.dtlst_pagination {
  margin: 0 auto;
  width: 96%;
  height: 25px;
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
}
</style>